import { render } from "./KontrolRombel.vue?vue&type=template&id=a32fec26"
import script from "./KontrolRombel.vue?vue&type=script&lang=js"
export * from "./KontrolRombel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__